<template>
    <div class="space-y-1">
        <nio-progress :color="usageColor" :percentage="usage" />
        <div class="text-sm whitespace-no-wrap" v-text="segmentLimitText" />
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState([
                'authUser',
                'segmentsUsage',
            ]),

            hasMonthlySegmentsLimit() {
                return !!this.authUser.account.monthly_segments_limit;
            },

            segmentLimitText() {
                return this.$t('configs.leftPanel.usage.segmentsSent', {
                    usage: this.segmentsUsage,
                    limit: this.authUser.account.monthly_segments_limit || 'N/A',
                });
            },

            usage() {
                if (!this.hasMonthlySegmentsLimit) {
                    return 0;
                }

                return Math.round(this.segmentsUsage / this.authUser.account.monthly_segments_limit * 100);
            },

            usageColor() {
                if (this.usage < 60) {
                    return 'green';
                }

                if (this.usage < 80) {
                    return 'orange';
                }

                return 'red';
            },
        },
    };
</script>
